<template>
  <div id="app" :class="{'no-scroll' : $route.name === 'BigPalette'}">
    <svg-loader v-if="isLoading" />
    <div class="mr-white" :class="{animateRight : showMrWhiteRight ,animateLeft : showMrWhiteLeft}"></div>
    <transition :duration="400" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import SvgLoader from "@/components/SvgLoader";
import { mapState } from "vuex";
import ouibounce from "ouibounce";
import router from "@/router";

export default {
  name: "app",
  components: {
    SvgLoader
  },
  computed: {
    ...mapState(["isLoading"])
  },
  data() {
    return {
      showMrWhiteRight: false,
      showMrWhiteLeft: false
    };
  },
  metaInfo: {
    title: "Flat UI Colors",
    titleTemplate:
      "%s | Flat UI Colors 🎨  280 handpicked colors ready for COPY & PASTE"
  },
  watch: {
    $route(to, from) {
      if (to.name == "Palettes") {
        this.setUpOuibounce();
      }

      if (from.name == "Onboarding") return;
      if (from.name == "Palettes") this.showMrWhiteRight = true;
      else this.showMrWhiteLeft = true;
      const that = this;

      setTimeout(() => {
        that.showMrWhiteRight = false;
        that.showMrWhiteLeft = false;
      }, 800);
    }
  },
  mounted() {
    if (localStorage.getItem("didBounce") === null) {
      localStorage.setItem("didBounce",0);
    }
  },
  methods: {
    setUpOuibounce() {
      return true;
      setTimeout(function() {
        if (localStorage.getItem("didBounce") != 1) {
          console.log("bounce setup");
          ouibounce(false, {
            aggressive: false,
            sensitivity: 40,
            callback: () => {
              console.log("bouncing");
              router.push({ path: "/subscribe" });
              localStorage.setItem("didBounce", 1);
            }
          });
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Luckiest+Guy");
@import url("https://fonts.googleapis.com/css?family=Barlow:600,700");
@import "~@/inc/_reset.scss";
@import "~@/inc/_helpers.scss";
@import "~@/styles/common.scss";

body{
  background: #3c40c6;
  background-image: url("~@/assets/stars-opacity.svg");
}

#app {
  font-family: "Barlow";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-weight: 600;
  &.no-scroll {
    overflow: hidden;
  }
}
.mr-white {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 100;
  overflow: hidden;
  transform: translateX(100%);
  &.animateRight {
    animation: moveFromRight 0.8s ease-in-out both;
  }
  &.animateLeft {
    animation: moveFromLeft 0.8s ease-in-out both;
  }
}
@keyframes moveFromRight {
  0% {
    transform: translateX(100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}
@keyframes moveFromLeft {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue